export function spliteDate(date) {
    return `${date.slice(0, 4)}/${date.slice(4, 6)}/${date.slice(6,)}`
}

export function spliteDateTime(date) {
    return `${date.slice(8, 10)}:${date.slice(10, 12)}:${date.slice(12, 14)}`
}

export function humanizeNumber(number) {
    const newNumber = number && String(number).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    return newNumber
}

export function fixFloatNumber(number) {
    return number && number.toFixed(2)
}

export const handleClassRederer = (data, number) => {
    return data > number ? 'text-primary' : 'text-danger'
}

export const handlePowerBuyClassRederer = (per_buy, per_sell) => {
    return per_buy < per_sell ? 'text-danger' : 'text-primary'
}

export const handleTvalRederer = (data) => {
    switch (data) {
        case "_":
            return 'text-danger'
        case "+":
            return 'text-primary'
        default:
            return ''
    }
}


export const stockRightList = [300, 303, 313, 309, 400, 403, 404]
// const stockFundList = [305, 380]

export const getStockRightFundList = (row) => {
    const fundFixedSymbol = stockRightList.includes(row.stock)
        ||
        (row.stock === 305 && (!row.l30.includes('ثابت') && !row.l30.endsWith('-د')))
    return fundFixedSymbol
}

export const getStockFundFixed = (row) => {
    return row.stock === '380' || (row.l30.includes('ثابت') || row.l30.endsWith('-د'))
}


export const hanleCrossValueClass = (row) => {
    const vol_buy_ha = row['legal']['vol buy ha']
    const vol_sell_ha = row['legal']['vol sell ha'] !== 0 ? row['legal']['vol sell ha'] : 1
    const count_buy_ha = row['legal']['count buy ha']
    const count_sell_ha = row['legal']['count sell ha'] !== 0 ? row['legal']['count sell ha'] : 1

    if (
        ((vol_buy_ha / count_buy_ha) * row['pc']) >= ((vol_sell_ha / count_sell_ha) * row['pc'])
    ) { return 'text-primary' }
    else { return 'text-danger' }
}

export const convertCurrency = (value) => {
    if (value !== undefined) {
        // Nine Zeroes for Billions
        if (Math.abs(Number(value)) >= 1.0e+9) {
            return `${(Math.abs(Number(value)) / 1.0e+9).toFixed(0)} B`
            // Six Zeroes for Millions
        } else if (Math.abs(Number(value)) >= 1.0e+6) {
            return (Math.abs(Number(value)) / 1.0e+6).toFixed(0) + " M"
            // Three Zeroes for Million
        } else if (Math.abs(Number(value)) >= 1.0e+3) {
            return (Math.abs(Number(value)) / 1.0e+3).toFixed(0) + " K"
        } else {
            return Math.abs(Number(value))
        }
    }

}

export const calculate_legal_buyer = (row) => {
    if (row['legal'] !== undefined && row['legal']) {
        if (row['legal']['vol buy ha'] === 0 || row['legal']['count buy ha'] === 0) {
            return 0
        } else {
            return (row['legal']['vol buy ha'] / row['legal']['count buy ha']) * row['pc']
        }
    } else {
        return 0
    }
}

export const calculate_legal_seller = (row) => {
    if (row['legal'] !== undefined && row['legal']) {
        if (row['legal']['vol sell ha'] === 0 || row['legal']['count sell ha'] === 0) {
            return 0
        } else {
            return (row['legal']['vol sell ha'] / row['legal']['count sell ha']) * row['pc']
        }
    } else {
        return 0
    }
    // return convert ? convertCurrency(legal_seller) : legal_seller
}


export const calculate_cross_value = (row) => {
    const legal_buyer = calculate_legal_buyer(row, false)
    const legal_seller = calculate_legal_seller(row, false)

    if (legal_buyer === 0 || legal_seller === 0) {
        return 0
    } else if (legal_buyer >= legal_seller) {
        return (legal_buyer / legal_seller)
    } else {
        return ((legal_seller / legal_buyer) * -1)
    }
}
